import Vue from 'vue'

import store from '../store'
import { collection, doc, getDoc, getDocs, limit, orderBy, query, where } from 'firebase/firestore'
import { firebaseDb } from '@web/firebase.js'

const initialState = {
  cursor: null,
  itemsById: {},
}

const dataConverter = () => ({
  toFirestore: modelObject => {
    return modelObject
  },

  fromFirestore: (snapshot, options) => {
    if (snapshot.exists) {
      const data = snapshot.data(options) || {}
      return {
        ...data,
        link: data.url,
        image: data.images ? data.images[data.images.length - 1] : null,
        icon: data.favicons ? data.favicons[0] : null,
        id: snapshot.id,
      }
    }

    return null
  },
})

const actions = {
  async fetchNext({ commit, state }) {
    const now = Date.now()

    let q = query(
      collection(firebaseDb, 'links'),
      where('published', '==', true),
      where('publishedTimestamp', '<=', now),
      orderBy('publishedTimestamp', 'desc'),
      limit(5),
    )
      .withConverter(dataConverter())

    if (state.cursor) {
      q = q.startAfter(state.cursor)
    }

    const snapshots = await getDocs(q)

    snapshots.docs.forEach(doc => {
      commit('ADD_ITEM', doc.data())
      commit('SET_CURSOR', doc)
    })
  },

  async fetchById({ commit }, id) {
    const docRef = doc(firebaseDb, 'links', id)
      .withConverter(dataConverter())

    const snapshot = await getDoc(docRef)

    if (snapshot.exists) {
      commit('ADD_ITEM', snapshot.data())
    } else {
      throw new Error('not found')
    }
  },
}

const getters = {
  newsfeed: state => {
    return Object.values(state.itemsById || {})
  },
  newsfeedById: state => id => {
    const { [id]: item } = state.itemsById || {}
    return item
  },
}

const mutations = {
  ADD_ITEM(state, item) {
    Vue.set(state.itemsById, item.id, item)
  },
  SET_CURSOR(state, cursor) {
    state.cursor = cursor
  },
}

store.registerModule('NEWSFEED', {
  namespaced: true,
  state: Object.assign({}, initialState),
  actions,
  mutations,
  getters,
})
